var map = {
	"./img_1.jpg": 11131,
	"./img_2.jpg": 50799,
	"./img_3.jpg": 33807,
	"./img_4.jpg": 11832,
	"./img_5.jpg": 33000,
	"./img_6.jpg": 70921
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 29303;